<template>
  <div>
    <div class="container">
      <section class="content mt-5">
        <div class="row">
          <div class="col-md-10 mx-auto text-sm-start text-md-center">
            <p class="text-primary label-top">TENTANG KAMI</p>
            <h1 class="fw-bold">APA ITU PUSAKA?</h1>
            <hr width="50%" class="d-sm-block d-none mx-auto"/>
            <p>
              PUSAKA yang disingkat Sistem Pemantuan Sekolah berfungsi untuk
              menyambungkan pihak sekolah dengan pusat agar pemantauan dapat
              dilakukan dengan terorganisir dan mempercepat respon dari pusat
              dengan adanya laporan online. Dengan adanya PUSAKA, diharapkan
              semua sekolah dapat membuat laporan kerusakan ataupun laporan lain
              dan dapat mempermudah proses pemantuan
            </p>
            <a href="#"
               class="btn btn-outline-primary px-4 py-2">Jelajahi ▾</a>
          </div>
        </div>
      </section>
    </div>

    <section class="about-section-2 mt-100" style="background-color: #d7edff">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <img src="assets/images/about-1.png" class="img-fluid" alt="" srcset=""/>
          </div>
          <div class="col-md-7 my-auto">
            <p class="text-primary label-top">TENTANG PUSAKA</p>
            <h1>Dibuat untuk memudahkan pemantauan dan laporan</h1>
            <p>
              Taukah kamu, PUSAKA dibuat dalam rangka membantu sekolah yang terkena bencana agar dapat
              melaporkan kondisi sekolah ke pusat tanpa ribet dan mudah
            </p>
            <a href="/login">
              <p class="text-primary"
                 style="text-decoration: none"> Selengkapnya →</p>
            </a>
          </div>
        </div>
      </div>
    </section>

    <section class="about-section-2 " style="background-color: #f2f6fb">
      <div class="container">
        <div class="row flex-column-reverse flex-md-row">
          <div class="col-md-7 my-auto">
            <p class="text-primary label-top">TENTANG PUSAKA</p>
            <h1>Dengan PUSAKA semua jadi lebih mudah!</h1>
            <p>
              Pihak pusat tidak perlu lagi untuk datang ke tempat untuk memantau dan mencatat kondisi sekolah
              yang terkena bencana atau musibah. Apalagi dengan maraknya kasus COVID-19, PUSAKA siap jadi
              alternatif dan mempermudah proses pelaporan.
            </p>
            <a href="/login">
              <p class="text-primary" style="text-decoration: none"> Selengkapnya →</p>
            </a>

          </div>
          <div class="col-md-5">
            <img src="assets/images/about-2.png" class="img-fluid" alt="" srcset=""/>
          </div>
        </div>
      </div>
    </section>

    <section class="about-section-2">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <img src="assets/images/about-3.png" class="img-fluid" alt="" srcset=""/>
          </div>
          <div class="col-md-7 my-auto">
            <p class="text-primary label-top">TENTANG PUSAKA</p>
            <h1>Dapat digunakan dimana saja & kapan saja</h1>
            <p>
              Versi android dari PUSAKA membuat laporan dapat dilakukan dimana saja dan kapan saja cukup
              dengan smartphone!
            </p>
            <a href="/login">
              <p class="text-primary"
                 style="text-decoration: none"> Selengkapnya →</p>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Tentang'
}
</script>
